import { BookingSummary, Participant, PaymentMethod } from 'modules/jogador/checkout/types';
import { ARENA_NAME, SERVICE_FEE, SPORT_LABEL } from 'modules/jogador/booking/content';

export const ORDER_ID = '#10428';

export const DEFAULT_BOOKING_SUMMARY: BookingSummary = {
  courtName: 'Areia 3 · coberta',
  time: '18:00',
  dateLabel: 'qui 12',
  pricePerHour: 80,
  splitEnabled: true,
  maxPlayers: 4,
};

export const MOCK_PARTICIPANTS: Participant[] = [
  { id: 'julia', name: 'Julia M.', status: 'paid', methodLabel: 'Cartão · pago' },
  { id: 'diego', name: 'Diego C.', status: 'waiting', methodLabel: 'Aguardando Pix' },
];

export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'pix', label: 'Pix' },
  { value: 'cartao', label: 'Cartão' },
];

export { ARENA_NAME, SERVICE_FEE, SPORT_LABEL };
